<template>
  <div class="sort-buttons-wrapper">
    <b-dropdown
      class="sort-button"
      :ref="section.type"
      right
      no-caret
      size="sm"
    >
      <template #button-content>
        {{ buttonLabel }}
        <font-awesome-icon class="right-icon" :icon="['far', 'chevron-down']"/>
      </template>
      <div class="sort-dropdown">
        <b-dropdown-item-button
          class="sort-option"
          v-for="(option, optionIndex) in sortOptions"
          :key="optionIndex"
          @click="selectOption(option)"
          :pressed="selectedSort.label === option.label">
          <font-awesome-icon
            class="radio-button-icon"
            :icon="selectedSort.label === option.label ? radioIcons.selected : radioIcons.unSelected"/>
          {{ option.label }}
        </b-dropdown-item-button>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SortButton',

  data: () => ({
    section: {
      label: 'Sort By',
      type: 'sort',
    },
    radioIcons: {
      unSelected: ['fal', 'square'],
      selected: ['fas', 'check-square'],
    },
    optionValue: null,
  }),

  computed: {
    ...mapGetters('sort', [
      'selectedSort',
      'sortOptions',
    ]),
    buttonLabel() {
      return this.selectedSort.label || this.section.label;
    },
  },

  methods: {
    ...mapActions('sort', [
      'updateSort',
    ]),

    async selectOption(option) {
      await this.updateSort(option)
    },
  },
}
</script>
<style lang="scss">
  .sort-buttons-wrapper {
    .sort-button {
      .dropdown-toggle-no-caret {
        border-radius: 4px;
        border: 1px solid var(--Navy-20, rgba(28, 36, 51, 0.20));
        height: 40px;
        padding: 8px 13px;
        align-items: center;
      }
    }
  }
</style>
